import { render } from "./ProductGiftPicker.vue?vue&type=template&id=5d664c6f&scoped=true"
import script from "./ProductGiftPicker.vue?vue&type=script&lang=js"
export * from "./ProductGiftPicker.vue?vue&type=script&lang=js"

import "./ProductGiftPicker.vue?vue&type=style&index=0&id=5d664c6f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d664c6f"]])

export default __exports__